import styled from 'styled-components';

export const Container = styled.div`
    min-width: 240px;
    max-width 320px;
    width: 30%;
    min-height: 50px;
    max-height: 100px;
    height: 10%;
    margin: auto;
    padding: 15px;
    display: flex;
    flex-direction: column;
    flex-wrap: no-wrap;
    justify-content: center;
    align-items: center;
`;

export const TrademarkText = styled.span`
    text-align: center;
    color: #003D50;
    font-size: 1.0rem;
    line-height: 22px;
    letter: normal;
    margin-top: 10px;
    min-width: 250px;
    max-width: 350px;
    width: 100%;
`;

export const TrademarkLink = styled.a`
  text-decoration: none;
  padding-bottom: 10px;
`;